var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormWrapper',{attrs:{"isLoading":_vm.isLoading}},[_c('PageTitle',{attrs:{"slot":"title","title":_vm.name},slot:"title"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }